
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[stateSlug]/[citySlug]",
      function () {
        return require("private-next-pages/[stateSlug]/[citySlug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[stateSlug]/[citySlug]"])
      });
    }
  